<template>
    <div :class="{'hstack':isHorizontal}" class="gap-2 position-relative" :required="isRequired ? true : null" :disabled="isDisabled ? true : null"> 
        <div class="form-check">
            <input :name="`flexRadioDefault${index}`" type="radio" class="" value="exact" required="true" v-model="selectionMode"/>
            <label class="form-check-label">Exact:</label>
        </div>
        <SelectField v-model="exactAge" ref="exactAgeSelect" :select-items="ageSelectItems" :is-horizontal="false" :is-disabled="selectionMode == 'range'" :is-required="isRequired && selectionMode == 'exact'" style="min-width:150px;">
        </SelectField>        
        <div class="form-check ms-5">
            <input :name="`flexRadioDefault${index}`" type="radio" class="" value="range" required="true" v-model="selectionMode" />
            <label class="form-check-label">Range:</label>
        </div>
        <SelectField v-model="minAge" ref="minAgeSelect" :select-items="minAgeSelectItems" :is-horizontal="false" :is-disabled="selectionMode == 'exact'" :is-required="isRequired && selectionMode == 'range'" style="min-width:150px;">
            <template #label><label class="position-absolute" style="top: -25px;">Min:</label></template>
        </SelectField>
        <SelectField v-model="maxAge" ref="maxAgeSelect" :select-items="maxAgeSelectItems" :is-horizontal="false" :is-disabled="selectionMode == 'exact'" :is-required="isRequired && selectionMode == 'range'" style="min-width:150px;">
            <template #label><label class="position-absolute" style="top: -25px;">Max:</label></template>
        </SelectField>
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType, ref, defineExpose, computed } from 'vue';    
    import { SelectItem, AgeRange } from '../../types';
    import SelectField from './SelectField.vue';
    import { useContactsStore } from '../../stores/contactsStore';
import { storeToRefs } from 'pinia';


    export default defineComponent({
        components: {
            SelectField
        },
        props: {
            index:Number,
            isDisabled: {
                default: false,
                type: Boolean
            },
            modelValue: {
                type: [Number,Object,String] as PropType<number | AgeRange | string>
            },
            isHorizontal: {
                default: false,
                type: Boolean
            },
            isRequired: {
                default: false,
                type: Boolean
            }
        },
        methods: {
            handleChange(){
                if(this.selectionMode === "exact") {
                    this.$emit('update:modelValue', isNaN(Number(this.exactAge)) ? 0 : this.exactAge);
                }
                else if(this.selectionMode === "range"){
                    let rangeData = {upper:this.maxAge, lower:this.minAge};

                    this.$emit('update:modelValue', rangeData);
                }
            },
            setMinMaxSelects(){
                if(this.selectionMode == 'range'){
                    let minRange = [...this.ages].splice(0, this.maxAge == -1 ? 99 : this.maxAge);
                    let maxRange = [...this.ages].splice((this.minAge == -1 ? 1 : this.minAge) - 1);
                    this.minAgeSelectItems = this.convertNumberToSelectItems(minRange);
                    this.maxAgeSelectItems = this.convertNumberToSelectItems(maxRange);
                }
            }
        },
        setup(props){
            const contactsStore = useContactsStore();

            contactsStore.fetchAges();

            var { ages } = storeToRefs(useContactsStore());
            
            var exactAge = ref(-1); 
            var selectionMode = ref("exact");
            var minAge = ref(-1);
            var maxAge = ref(-1);

            if(props.modelValue){
                
                if(typeof(props.modelValue)=='number'){
                    exactAge = ref(props.modelValue as number);
                    selectionMode = ref("exact");
                }
                else if(typeof(props.modelValue)=='object'){
                    const data = props.modelValue as AgeRange;

                    if(data.upper != undefined){
                        maxAge = ref(data.upper);
                    }

                    if(data.lower != undefined){
                        minAge = ref(data.lower);
                    }

                    selectionMode= ref("range");
                }                
            }

            const exactAgeSelect = ref({} as any);
            const minAgeSelect = ref({} as any);
            const maxAgeSelect = ref({} as any);

            var isComponentValid = ref();
            const isValid = ():Boolean => {
                
                if(selectionMode.value == ""){
                    isComponentValid.value = false;
                }

                if(props.isRequired){
                    isComponentValid.value = (selectionMode.value == "exact" && exactAgeSelect.value?.isValid()) || (selectionMode.value == "range" && minAgeSelect.value?.isValid() && maxAgeSelect.value?.isValid());
                }
                else{
                    isComponentValid.value = true;
                }

                return isComponentValid.value;
            }

            defineExpose({ isValid })

            const convertNumberToSelectItems = (ageRange):SelectItem[] => {
                let items = [] as SelectItem[];
                items.push({label:``, value:`-1`, isDisable:true});

                Array.from([...ageRange], x=> items.push({label:`${x}`, value:`${x}`, isDisable:false}));
                return items;
            };

            const ageSelectItems = ref(convertNumberToSelectItems(ages.value));
            const minAgeSelectItems = ref(convertNumberToSelectItems([...ages.value].splice(0, maxAge.value -1)));
            const maxAgeSelectItems = ref(convertNumberToSelectItems([...ages.value].splice(minAge.value -1)));

            return { contactsStore, 
                exactAge, 
                selectionMode,
                minAge,
                maxAge,
                isComponentValid,
                isValid,
                ages,
                exactAgeSelect,
                minAgeSelect,
                maxAgeSelect,
                convertNumberToSelectItems,
                ageSelectItems,
                minAgeSelectItems,
                maxAgeSelectItems };
        },
        watch: {
            exactAge(newValue, oldValue) {
                this.handleChange();
            },
            minAge(newValue, oldValue) {                
                this.handleChange();

                this.setMinMaxSelects();
            },
            maxAge(newValue, oldValue) {
                this.handleChange();

                this.setMinMaxSelects();
            },
            selectionMode(newValue, oldValue){
                this.setMinMaxSelects();
            },
            modelValue(newValue, oldValue) {
                this.exactAge = -1; 
                this.selectionMode = "";
                this.minAge = -1;
                this.maxAge = -1;

                if(typeof(this.modelValue)=='number'){
                    this.exactAge = this.modelValue as number;
                    this.selectionMode = ("exact");
                }
                else if(typeof(this.modelValue)=='object'){
                    const data = this.modelValue as AgeRange;

                    if(data.upper != undefined){
                        this.maxAge = (data.upper);
                    }

                    if(data.lower != undefined){
                        this.minAge = (data.lower);
                    }

                    this.selectionMode= ("range");
                }                
            }
        }
    });
</script>